(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spotlight-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spotlight-carousel')) {
    class SpotlightCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-spb-track]');
        this.viewport = this.querySelector('[data-spb-viewport]');
        this.toggle = this.querySelector('[data-spb-toggle]');
        this.counter = this.querySelector('[data-spb-counter]');
        if (!this.track || !this.viewport || this.dataset.built === 'true') return;

        this.originals = Array.from(this.track.children);
        this.count = this.originals.length;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'false' || this.count < 3 || reduced) return;

        this.delay = Math.max(1, parseFloat(this.dataset.interval) || 1) * 1000;
        this.duration = Math.min(900, Math.round(this.delay * 0.6));
        this.style.setProperty('--spb-speed', `${this.duration}ms`);
        this.state = { user: false, hover: false, focus: false, visible: false, editor: false };
        this.build();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        if (this.observer) this.observer.disconnect();
        if (this.resizer) this.resizer.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      build() {
        const makeClone = (item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.removeAttribute('data-spb-card');
          clone.querySelectorAll('a, button').forEach((node) => node.setAttribute('tabindex', '-1'));
          return clone;
        };

        this.track.prepend(...this.originals.map(makeClone));
        this.track.append(...this.originals.map(makeClone));
        this.items = Array.from(this.track.children);
        this.index = this.count;
        this.dataset.built = 'true';
        this.classList.add('is-carousel');
        this.render(false);
        this.bind();
      }

      step() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return this.items[0].getBoundingClientRect().width + gap;
      }

      render(animate) {
        if (!animate) this.classList.add('is-instant');
        this.items.forEach((item, i) => item.classList.toggle('is-active', i === this.index));
        this.track.style.transform = `translate3d(${-this.index * this.step()}px, 0, 0)`;
        if (this.counter) {
          const current = (this.index % this.count) + 1;
          this.counter.textContent = `${String(current).padStart(2, '0')} / ${String(this.count).padStart(2, '0')}`;
        }
        if (!animate) {
          void this.track.offsetWidth;
          this.classList.remove('is-instant');
        }
      }

      go(delta) {
        this.index += delta;
        this.render(true);
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), this.duration + 60);
      }

      settle() {
        if (this.index >= this.count * 2) {
          this.index -= this.count;
          this.render(false);
        } else if (this.index < this.count) {
          this.index += this.count;
          this.render(false);
        }
      }

      paused() {
        const s = this.state;
        return s.user || s.hover || s.focus || s.editor || !s.visible || document.hidden;
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.paused()) return;
        this.timer = setTimeout(() => {
          this.go(1);
          this.schedule();
        }, this.delay);
      }

      setState(key, value) {
        this.state[key] = value;
        this.schedule();
      }

      bind() {
        this.addEventListener('mouseenter', () => this.setState('hover', true));
        this.addEventListener('mouseleave', () => this.setState('hover', false));

        this.addEventListener('focusin', (event) => {
          const card = event.target.closest('[data-spb-card]');
          const position = this.items.indexOf(card);
          if (card && position > -1 && position !== this.index) {
            this.index = position;
            this.render(true);
          }
          this.setState('focus', true);
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.setState('focus', false);
        });

        if (this.toggle) {
          this.toggle.addEventListener('click', () => {
            const paused = !this.state.user;
            this.classList.toggle('is-paused', paused);
            this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
            this.setState('user', paused);
          });
        }

        let startX = 0;
        let startY = 0;
        let tracking = false;
        this.suppressClick = false;
        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          tracking = true;
          startX = event.clientX;
          startY = event.clientY;
        });
        this.viewport.addEventListener('pointerup', (event) => {
          if (!tracking) return;
          tracking = false;
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.suppressClick = true;
            this.go(dx < 0 ? 1 : -1);
            this.schedule();
          }
        });
        this.viewport.addEventListener('pointercancel', () => {
          tracking = false;
        });
        this.viewport.addEventListener('click', (event) => {
          if (this.suppressClick) {
            event.preventDefault();
            this.suppressClick = false;
          }
        }, true);
        this.viewport.addEventListener('dragstart', (event) => event.preventDefault());

        this.observer = new IntersectionObserver((entries) => {
          const visible = entries.some((entry) => entry.isIntersecting);
          if (visible && !this.imagesReady) {
            this.imagesReady = true;
            this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
              img.loading = 'eager';
            });
          }
          this.setState('visible', visible);
        }, { threshold: 0.25 });
        this.observer.observe(this);

        this.onVisibility = () => this.schedule();
        document.addEventListener('visibilitychange', this.onVisibility);

        this.lastWidth = this.viewport.clientWidth;
        this.resizer = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (width !== this.lastWidth) {
            this.lastWidth = width;
            this.render(false);
          }
        });
        this.resizer.observe(this.viewport);

        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-spb-card]');
          const position = this.items.indexOf(card);
          if (position > -1) {
            this.index = position;
            this.render(true);
          }
          this.setState('editor', true);
        });
        this.addEventListener('shopify:block:deselect', () => this.setState('editor', false));
      }
    }

    customElements.define('spotlight-carousel', SpotlightCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
